import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/** Slim banner shown while the browser is offline — the PWA serves last-known data. */
export const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;
  return (
    <div
      data-testid="offline-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-[#A67C00] text-[#1A1F16] text-center py-2 font-mono text-[10px] uppercase tracking-[0.25em] flex items-center justify-center gap-2"
    >
      <WifiOff className="w-3 h-3" /> Offline — showing your last-synced ledger
    </div>
  );
};
